import React from 'react';
import styled from 'styled-components';

const FilterStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 5rem;
  flex-wrap: wrap;
  
  .filter-btn {
    padding: 1.2rem 2.5rem;
    font-size: 1.5rem;
    font-weight: 500;
    background: ${props => props.active ? 'var(--gradient-primary)' : 'var(--glass-bg)'};
    color: var(--text-primary);
    border: 1px solid ${props => props.active ? 'transparent' : 'var(--glass-border)'};
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: var(--transition-normal);
    backdrop-filter: blur(10px);
    position: relative;
    overflow: hidden;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--gradient-primary);
      opacity: 0;
      transition: var(--transition-normal);
      z-index: -1;
    }
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: var(--shadow-glow);
      border-color: transparent;
      
      &::before {
        opacity: 1;
      }
    }
    
    &.active {
      box-shadow: var(--shadow-glow);
      
      &::before {
        opacity: 1;
      }
    }
    
    .count {
      display: inline-block;
      margin-left: 0.5rem;
      padding: 0.2rem 0.8rem;
      background: rgba(255, 255, 255, 0.15);
      border-radius: var(--radius-sm);
      font-size: 1.2rem;
      font-weight: 600;
    }
  }
  
  @media only screen and (max-width: 768px) {
    gap: 1rem;
    
    .filter-btn {
      padding: 1rem 2rem;
      font-size: 1.3rem;
      
      .count {
        font-size: 1.1rem;
        padding: 0.2rem 0.6rem;
      }
    }
  }
`;

export default function ProjectFilter({ categories, activeCategory, onFilterChange, projectCounts }) {
  return (
    <FilterStyles>
      {categories.map((category) => (
        <button
          key={category.id}
          className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
          onClick={() => onFilterChange(category.id)}
        >
          {category.name}
          <span className="count">{projectCounts[category.id] || 0}</span>
        </button>
      ))}
    </FilterStyles>
  );
}
